import { useState } from 'react';
import AIHelpChat from './AIHelpChat';
import AmoxtliIcon from './AmoxtliIcon';

const AIHelpButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Botón flotante del asistente IA (DERECHA) */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-6 right-6 w-14 h-14 bg-gradient-to-br from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-full shadow-lg hover:shadow-xl transition-all flex items-center justify-center z-30 hover:scale-110"
        title="Abrir asistente de IA"
      >
        <AmoxtliIcon variant="stamp" className="h-7 w-7" alt="Sello fiscal Amoxtli" />
      </button>

      {/* Chat modal */}
      <AIHelpChat isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default AIHelpButton;
